import { c as sanitizeMetadata } from "./sanitizer-CLnKD_rP.js";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";
import { StatsigTriggeredSessionReplayPlugin } from "@statsig/session-replay";

//#region src/plugins.ts
/**
* Plugin factories for `@jotpsych/statsig`.
*
* Statsig only binds plugins during client construction on first render.
* Any plugin pushed into `options.plugins` after that is silently ignored
* (see `@statsig/js-client/StatsigClient.js` constructor: plugins are
* iterated + `bind(this)`'d once). So plugin instances must be constructed
* synchronously by the consumer and passed into `StatsigProvider` on its
* first render.
*
* This file is deliberately a subpath export (`@jotpsych/statsig/plugins`)
* so that consumers who don't want auto-capture or session replay don't
* drag their packages into the bundle. Apps that don't use plugins can
* skip installing `@statsig/web-analytics` / `@statsig/session-replay`.
*/
/**
* Auto-capture plugin with `sanitizeMetadata` wired into `eventFilterFunc`.
*
* This is the only supported path for constructing the auto-capture plugin in
* SmartScribe apps — constructing `StatsigAutoCapturePlugin` directly skips
* PHI scrubbing on auto-captured page_view / click / form_submit events.
*
* @example
* const plugins = useMemo(() => [createSanitizedAutoCapturePlugin()], []);
* <StatsigProvider plugins={plugins} ... />
*/
function createSanitizedAutoCapturePlugin(options) {
	return new StatsigAutoCapturePlugin({
		...options,
		eventFilterFunc: (event) => {
			if (event.metadata) event.metadata = sanitizeMetadata(event.metadata);
			return true;
		}
	});
}
/**
* Triggered session replay plugin with SmartScribe's standard rrweb config
* (block class `rr-block`, mask class `rr-mask`, recording disabled by default —
* `startCapture()` on `useSessionReplayCapture()` to begin).
*
* @example
* const plugins = useMemo(() => [createTriggeredSessionReplayPlugin()], []);
* <StatsigProvider plugins={plugins} ... />
*/
function createTriggeredSessionReplayPlugin(overrides) {
	return new StatsigTriggeredSessionReplayPlugin({
		autoStartRecording: false,
		keepRollingWindow: true,
		rrwebConfig: {
			blockClass: "rr-block",
			maskTextClass: "rr-mask",
			sampling: {
				scroll: 50,
				input: "last"
			}
		},
		...overrides
	});
}

//#endregion
export { createSanitizedAutoCapturePlugin, createTriggeredSessionReplayPlugin };
//# sourceMappingURL=plugins.js.map